'use strict';

// All prices are listed in pence so £22 = 2200
class Pricelist {

    static get() {
        return {
            'fixings': {
                'singleGlazedHeadTrack': 2200,
                'singleGlazedHeadTrackGasket': 179,
                'singleGlazedBaseTrack': 867,
                'singleGlazedCoverPlates': 510,
                'singleGlazedGaskets10mmGlass': 12,
                'singleGlazedGaskets12mmGlass': 10,
                'singleGlazedStandardWallAbutment': 2200,
                'singleGlazedWallAbutmentGasket': 179,
                'doubleGlazedHeadTrack': 2649,
                'doubleGlazedHeadTrackGasket': 358,
                'doubleGlazedBaseTrack': 2208,
                'doubleGlazedCoverPlates': 1020,
                'doubleGlazedInnerGasket': 46,
                'doubleGlazedStandardWallAbutment': 2649,
                'doubleGlazedStandardWallAbutmentGasket': 358,
            },
            'doors': {
                'noDoor': 0,
                'singleGlazedDoorFrameless': 52100,
                'singleGlazedDoorIncFrame': 74830,
                'singleGlazedDoorIncDoubleGlazedFrame': 78790,
                'doubleGlazedDoor': 146200,
            },
            'ironmongery': {
                'dHandle': 0,
                'manet': 0,
                'leverLock': 14800,
            },
            'manifestations': {
                'dotsOrSquares': 1550,
                'opalFrostBand': 3600,
                'opalFrostFull': 3000,
            },
            'labour': {
                'single': 1500,
                'double': 2000,
                'total': 25000,
            },
            'margin': {
                'singleGlazedInline': 40,
                'singleGlazedCorner': 35,
                'singleGlazedThreeSided': 35,
                'singleGlazedTShape': 30,
                'doubleGlazedInline': 20,
                'doubleGlazedCorner': 10,
                'doubleGlazedThreeSided': 10,
                'doubleGlazedTShape': 10,
            },
            'glass': {
                '1': 5187, // single glazed toughened 10mm
                '2': 7717, // single glazed toughened 12mm
                '3': 14283, // double glazed, toughened 10mm & toughened 12mm (one sheet of each)
                '4': 8737, // single glazed, acoustic laminate 10.8mm
                '5': 9553, // single glazed, acoustic laminate 12.8mm
            },
            'additional': {
                'general': 10000,
                'delivery': 0
            },
        }
        ;
    }
}

export { Pricelist }



// WEBPACK FOOTER //
// ./src/objects/Pricelist.js